import React from "react";
import { hero } from "../mock";
import { asset } from "../assetBase";
import { Linkedin, Download } from "lucide-react";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${asset("/assets/hero.webp")})` }}
      />
      {/* Light overlay to keep text legible */}
      <div className="absolute inset-0 bg-white/60" />
      <div className="absolute inset-0 bg-gradient-to-r from-white/75 via-white/40 to-white/70" />

      <div className="relative z-10 max-w-6xl mx-auto w-full px-6 md:px-10 text-right md:pr-16">
        <div className="ml-auto max-w-3xl">
          <h1 className="font-head font-extrabold text-neutral-800 text-5xl md:text-7xl leading-tight">
            {hero.name}
          </h1>

          <p className="mt-6 text-neutral-700 tracking-body text-sm md:text-base">
            {hero.roles.join(" | ")}
          </p>

          <p className="mt-3 text-neutral-700 tracking-body text-base md:text-lg">
            {hero.welcome}
          </p>

          <div className="mt-10 flex flex-wrap justify-end gap-4">
            <a
              href={hero.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-lime-500 hover:bg-lime-600 text-neutral-900 font-head font-semibold text-sm px-8 py-4 rounded transition-all duration-200 hover:-translate-y-0.5 shadow-sm hover:shadow-md"
            >
              <Linkedin size={18} /> LinkedIn
            </a>
            <a
              href={hero.cv}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-lime-500 hover:bg-lime-600 text-neutral-900 font-head font-semibold text-sm px-8 py-4 rounded transition-all duration-200 hover:-translate-y-0.5 shadow-sm hover:shadow-md"
            >
              <Download size={18} /> Download CV
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
